<template>
  <div>
    <div style="display: flex; align-items: center;" v-for="(answer, answerIndex) in question.answers" :key="answerIndex">
      <div style="display: inline-flex">{{ answer.label }}.</div>
      <div v-html="answer.value || ''" style="margin-left: 4px"></div>
      <div v-if="!submission.isQuestionPaper && isAnswerShown" style="display: inline-flex" class="ml-2">
        <div v-if="isStudentAnswerShown(answer.key)">
          <span 
            v-if="!submission.isStudentWork"
            :style="{ color: isCorrect ? '#4bca81' : '#d4504c', fontWeight: 'bold', fontSize: '14px' }"
            v-html="isCorrect ? '&#10003;' : '&#x2715;'"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import get from 'lodash-es/get'
import {mapGetters} from 'vuex'
export default {
  props: {
    question: Object,
  },
  computed: {
    ...mapGetters({
      submission: 'pdfRender/getSubmission',
    }),
    isAnswerShown() {
      return this.submission.answers && this.submission.answers[this.question.id]
    },
  },
  methods: {
    isStudentAnswerShown(ansKey = '') {
      const studentAnswer = this.submission.answers[this.question.id]
      return get(studentAnswer, 'answerIds', []).includes(ansKey)
    },
    isStudentAnswerWrong(ansKey) {
      const studentAnswer = this.submission.answers[this.question.id]
      return get(studentAnswer, 'correct', []).includes(ansKey)
    },
  },
}
</script>
